var _circle, _rect, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#2977dd",
    cx: 24,
    cy: 24,
    r: 21
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    fill: "#fff",
    width: 4,
    height: 11
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 24,
    cy: 16.5,
    r: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.de027c822d22cc099a725fb9b8ff475c.svg";
export { ForwardRef as ReactComponent };